import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/header.css';
import logo from '../images/logo-new.png';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Determine active page based on current pathname
  const getActivePage = () => {
    const pathname = window.location.pathname;
    
    // For React Router paths (/app/)
    if (pathname === '/app' || pathname.startsWith('/app/')) {
      return 'events';
    }
    
    // For static pages (landing at root)
    if (
      pathname === '/' ||
      pathname === '/index.html' ||
      pathname === '/index-home.html'
    ) {
      return 'home';
    }
    if (pathname.includes('/blogs/')) {
      return 'blogs';
    }
    if (pathname.includes('/about')) {
      return 'about';
    }
    
    // Default to events if we're in React app
    return 'events';
  };
  
  const activePage = getActivePage();

  // Force override MUI styles
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .site-header__logo-my-events {
        font-family: 'Alex Brush', cursive !important;
        font-weight: 400 !important;
      }
      .site-header__logo-bridge {
        font-family: 'Montserrat', sans-serif !important;
        font-weight: 300 !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Handle external links (not /app/) - force full page reload
  const handleExternalLink = (e, href) => {
    // Only intercept if it's not a React app link (/app/)
    if (!href.startsWith('/app/')) {
      e.preventDefault();
      window.location.href = href;
    }
  };

  return (
    <header className="site-header">
      <div className="site-header__container">
        <a 
          href="/" 
          className="site-header__logo" 
          onClick={(e) => {
            closeMobileMenu();
            handleExternalLink(e, '/');
          }}
        >
          <img src={logo} alt="My Events Bridge Logo" className="site-header__logo-image" />
          <div className="site-header__logo-text">
            <p className="site-header__logo-my-events">My Events</p>
            <p className="site-header__logo-bridge">BRIDGE</p>
          </div>
        </a>
        
        {/* Hamburger Menu Button */}
        <button 
          className={`site-header__menu-toggle ${mobileMenuOpen ? 'site-header__menu-toggle--active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Desktop Navigation */}
        <nav className="site-header__nav site-header__nav--desktop">
          <a 
            href="/" 
            className={`site-header__nav-link ${activePage === 'home' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => handleExternalLink(e, '/')}
          >
            Home
          </a>
          <Link
            to="/"
            className={`site-header__nav-link ${activePage === 'events' ? 'site-header__nav-link--active' : ''}`}
          >
            Events
          </Link>
          <a 
            href="/blogs/" 
            className={`site-header__nav-link ${activePage === 'blogs' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => handleExternalLink(e, '/blogs/')}
          >
            Stories and Reviews
          </a>
          <a 
            href="/about.html" 
            className={`site-header__nav-link ${activePage === 'about' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => handleExternalLink(e, '/about.html')}
          >
            About
          </a>
        </nav>

        {/* Mobile Navigation */}
        <nav className={`site-header__nav site-header__nav--mobile ${mobileMenuOpen ? 'site-header__nav--mobile-open' : ''}`}>
          <a 
            href="/" 
            className={`site-header__nav-link ${activePage === 'home' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => {
              closeMobileMenu();
              handleExternalLink(e, '/');
            }}
          >
            Home
          </a>
          <Link
            to="/"
            className={`site-header__nav-link ${activePage === 'events' ? 'site-header__nav-link--active' : ''}`}
            onClick={closeMobileMenu}
          >
            Events
          </Link>
          <a 
            href="/blogs/" 
            className={`site-header__nav-link ${activePage === 'blogs' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => {
              closeMobileMenu();
              handleExternalLink(e, '/blogs/');
            }}
          >
            Stories and Reviews
          </a>
          <a 
            href="/about.html" 
            className={`site-header__nav-link ${activePage === 'about' ? 'site-header__nav-link--active' : ''}`}
            onClick={(e) => {
              closeMobileMenu();
              handleExternalLink(e, '/about.html');
            }}
          >
            About
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;

